var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"store-form"},[_c('PageBack'),_c('Form',{attrs:{"title":_vm.title,"fields":_vm.fields,"model":_vm.model,"action":_vm.action},on:{"success":function($event){return _vm.$emit('success')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }